import {css} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../../../../../contexts';

const useStyles = (active: boolean) => {
    const theme = useWolfTheme();

    return useMemo(
        () => ({
            wrapper: css({
                padding: theme.orbitalTwo,
                transition: '300ms background-color',
                color: `${theme.palette.foreground.default} !important`,
                textDecoration: `none !important`,
                borderRadius: theme.borderRadius3,
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                gap: theme.orbitalTwo,
                cursor: 'pointer',
                border: 'none',
                justifyContent: 'space-between',
                fontSize: '16px',
                background: active ? theme.palette.neutral.background : 'none',
                boxSizing: 'border-box',

                '&:focus-visible': {
                    outlineColor: `${theme.palette.primary.default} !important`,
                    outlineOffset: 2,
                    outlineWidth: 2,
                    outlineStyle: 'solid',
                },

                '&:hover, &:focus-visible': {
                    background: theme.palette.neutral.background,
                },
            }),

            label: css({
                display: 'flex',
                alignItems: 'center',
                gap: 6,
            }),

            icon: css({
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
            }),
        }),
        [theme, active]
    );
};

export default useStyles;
